import React from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { msalConfig, loginRequest } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

function SignInPage() {
  const { instance } = useMsal();
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      fontFamily: "Segoe UI, sans-serif",
      backgroundColor: "#f5f5f5"
    }}>
      <div style={{
        background: "white",
        padding: 40,
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        textAlign: "center"
      }}>
        <h2 style={{ marginBottom: 8, color: "#333" }}>Team Tools</h2>
        <p style={{ color: "#666", marginBottom: 24 }}>Sign in with your Microsoft work account to continue</p>
        <button
          onClick={() => instance.loginPopup(loginRequest)}
          style={{
            backgroundColor: "#0078d4",
            color: "white",
            border: "none",
            padding: "12px 24px",
            fontSize: 15,
            borderRadius: 4,
            cursor: "pointer"
          }}
        >
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}

export function AuthProvider({ children }) {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate><SignInPage /></UnauthenticatedTemplate>
    </MsalProvider>
  );
}